import { useMemo } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';
import profileImageNull from '../../assets/profile/profile.png';
import EditPurpleIcon from '../../assets/common/EditPencilIcon';
import useTranslations from '../../hooks/useTranslations';

export const SubskillRow = ({
  subskill,
  onClickSetSubskillSelected,
  onAddSubskill = () => {},
  onRemoveSubskill = () => {},
  onSelectSubskillToUpdate = () => {},
  subskillSelected,
  canSelect,
  buttonPlus = false,
}) => {
  const { key } = useTranslations();

  const isChildrenOfSelected = useMemo(
    () => !!(subskillSelected?.id === subskill?.parentId),
    [subskillSelected?.id, subskill?.parentId]
  );
  const isSiblingOfSelected = useMemo(
    () =>
      !!(subskillSelected?.parentId != null && subskillSelected?.parentId === subskill?.parentId),
    [subskillSelected?.parent?.children, subskill?.id]
  );
  const isGrandchildrenOfSelected = useMemo(
    () =>
      subskill?.parent &&
      subskill?.parent?.parentId &&
      subskill?.parent?.parentId === subskillSelected?.id,
    [subskill, subskillSelected?.id]
  );
  const isGrandparentOfSelected = useMemo(
    () =>
      subskillSelected &&
      subskillSelected?.parent &&
      subskillSelected?.parent?.parentId &&
      subskill?.id === subskillSelected?.parent?.parentId,
    [subskill?.id, subskillSelected?.parent?.parentId]
  );

  const isParentOfSelected = useMemo(
    () => subskillSelected?.parentId && subskillSelected?.parentId === subskill?.id,
    [subskill?.id, subskillSelected?.parentId]
  );
  const isSomeOfSelected = useMemo(
    () =>
      isChildrenOfSelected ||
      isSiblingOfSelected ||
      isGrandchildrenOfSelected ||
      isGrandparentOfSelected ||
      isParentOfSelected,
    [
      isChildrenOfSelected,
      isSiblingOfSelected,
      isGrandchildrenOfSelected,
      isGrandparentOfSelected,
      isParentOfSelected,
    ]
  );

  const selectedIsGrandChildren = useMemo(
    () => !!(subskillSelected?.parent && subskillSelected?.parent?.parentId),
    [subskillSelected?.parent?.parentId]
  );

  const isGrandchildren = useMemo(
    () => !!(subskill?.parent && subskill?.parent?.parentId),
    [subskill?.parent?.parentId]
  );

  const onClickSelectSubskill = () => {
    onSelectSubskillToUpdate(subskill);
  };
  return (
    <div
      className="test-button-filters-selected d-flex justify-content-between align-items-center"
      style={
        isSomeOfSelected
          ? {
              backgroundColor: '#4987be',
              color: 'white',
            }
          : {}
      }
    >
      <div className="ml-2">
        <img
          className="user-heading-img rounded-circle p-"
          style={{ width: '50px', height: '50px', filter: isSomeOfSelected ? 'invert(1)' : 'none' }}
          src={subskill?.iconUrl || profileImageNull}
          alt={t('PROFILE_MENU_LOGO_USER')}
        />
      </div>
      <div className="m-2 d-flex justify-content-around flex-column">
        <span
          style={
            isSomeOfSelected
              ? {
                  color: 'white',
                }
              : {}
          }
        >
          {subskill?.languages ? subskill?.languages[key] ?? subskill?.name : subskill?.name}
        </span>
      </div>
      <div className="d-flex">
        {!subskillSelected && (
          <button
            type="button"
            data-testid="create-evaluation-second-step-button"
            className={`bg-transparent p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
            style={isSomeOfSelected ? { borderColor: '#FFFF' } : {}}
            onClick={() => onClickSelectSubskill()}
          >
            <span
              className={` test-text-filters ${'test-text-filters-selected'}`}
              data-testid="create-evaluation-ss-filters-selected-span"
              style={{ color: '#449cc8' }}
            >
              <EditPurpleIcon />
            </span>
          </button>
        )}

        {canSelect && (
          <button
            type="button"
            data-testid="create-evaluation-second-step-button"
            className={`bg-transparent p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
            style={isSomeOfSelected ? { borderColor: '#FFFF' } : {}}
            onClick={() => onClickSetSubskillSelected(subskill)}
          >
            <span
              className={` test-text-filters ${'test-text-filters-selected'}`}
              data-testid="create-evaluation-ss-filters-selected-span"
              style={isSomeOfSelected ? { color: '#FFFF' } : {}}
            >
              {t('SUBSKILL_SELECT')}
            </span>
          </button>
        )}
        {buttonPlus &&
          subskillSelected &&
          !selectedIsGrandChildren &&
          !isParentOfSelected &&
          !isGrandparentOfSelected &&
          !isGrandchildren &&
          !isChildrenOfSelected &&
          subskill?.children?.length === 0 && (
            <button
              type="button"
              data-testid="create-evaluation-second-step-button"
              className={`bg-transparent p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
              onClick={() => onAddSubskill({ parent: subskillSelected, subskillToAdd: subskill })}
              style={isSomeOfSelected ? { borderColor: '#FFFF' } : {}}
            >
              <span
                className={` test-text-filters ${'test-text-filters-selected'}`}
                data-testid="create-evaluation-ss-filters-selected-span"
                style={isSomeOfSelected ? { color: '#FFFF' } : {}}
              >
                {t('+')}
              </span>
            </button>
          )}
        {subskillSelected && isChildrenOfSelected && (
          <button
            type="button"
            data-testid="create-evaluation-second-step-button"
            className={`bg-transparent p-2 d-flex m-2 justify-content-center align-items-center  ${'test-button-filters'}`}
            style={isSomeOfSelected ? { borderColor: '#FFFF' } : {}}
            onClick={() =>
              onRemoveSubskill({
                subskillToRemove: subskill,
              })
            }
          >
            <span
              className={` test-text-filters ${'test-text-filters-selected'}`}
              data-testid="create-evaluation-ss-filters-selected-span"
              style={isSomeOfSelected ? { color: '#FFFF' } : {}}
            >
              <ArrowLeftOutlined />
            </span>
          </button>
        )}
      </div>
    </div>
  );
};
